import { render } from "./CommonRichTableWithAxios.vue?vue&type=template&id=6533399f&ts=true&lang=pug"
import script from "./CommonRichTableWithAxios.vue?vue&type=script&lang=ts"
export * from "./CommonRichTableWithAxios.vue?vue&type=script&lang=ts"

import "./CommonRichTableWithAxios.vue?vue&type=style&index=0&id=6533399f&lang=scss"

import exportComponent from "C:\\Users\\ZiegFreeze\\Documents\\Work\\upa-fast-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__